// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "bootstrap"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import "bootstrap-datepicker/js/bootstrap-datepicker"

import 'select2';                       // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';
import "@fortawesome/fontawesome-free/css/all"
require.context("../images", true)

document.addEventListener('turbolinks:before-cache', function () {
    $("select").select2('destroy');
});

document.addEventListener("turbolinks:load", function() {
    $('.select2').select2();
    $('.datepicker').datepicker({
        language: 'en',
        format: 'mm-dd-yyyy'
    });
    $(".select2").on('select2:open', () => {
        document.querySelector('input.select2-search__field') &&
        document.querySelector('input.select2-search__field').focus();
    });
    $("#menu-toggle").click(function(e) {
        e.preventDefault();
        $("#wrapper").toggleClass("toggled");
    });

    // Enable Bootstrap tooltip
    $('[data-bs-toggle="tooltip"]').map((el) => new Tooltip(el));

    function sidebarResize() {
        if ($(window).width() >= 768) {
            $("#wrapper").addClass("toggled");
        } else {
            $("#wrapper").removeClass("toggled");
        }
    }

    $(window).resize(sidebarResize);
    sidebarResize();
})
